import { PaymentMethod } from '@models/order';

/** 다음 주문에 기본값으로 저장해 둘 수 있는 결제수단 */
export const SAVE_ABLE_PAYMENT_METHODS: PaymentMethod[] = [
    'CREDIT_CARD', 'EASY_CARD',
    'MOBILE_PAYMENT', 'KAKAO_PAY', 'APPLE_PAY', 'NAVER_PAY',
    'TOSS_PAY', 'TOSS_PAY_DIRECT', 'PAYCO',
];

/** 포인트 사용 단위 */
export const POINT_USE_UNIT = 1000;
